import React from 'react';
import { Icon } from '../UI/Components/Icons/Icons';

const types = [
    {
        name: 'Other',
        icon: () => <Icon.Other />,
    },
    {
        name: 'Aerobics',
        icon: () => <Icon.Aerobics />,
    },
    {
        name: 'Animal Movement',
        icon: () => <Icon.AnimalMovement />,
    },
    {
        name: 'Barre',
        icon: () => <Icon.Barre />,
    },
    {
        name: 'Bodyweight',
        icon: () => <Icon.Bodyweight />,
    },
    {
        name: 'Bootcamp',
        icon: () => <Icon.Bootcamp />,
    },
    {
        name: 'Boxing',
        icon: () => <Icon.Boxing />,
    },
    {
        name: 'Calisthenics',
        icon: () => <Icon.Calisthenics />,
    },
    {
        name: 'Circuit Training',
        icon: () => <Icon.CircuitTraining />,
    },
    {
        name: 'Conditioning',
        icon: () => <Icon.Conditioning />,
    },
    {
        name: 'Core',
        icon: () => <Icon.Core />,
    },
    {
        name: 'Crossfit',
        icon: () => <Icon.Crossfit />,
    },
    {
        name: 'HIIT',
        icon: () => <Icon.HIIT />,
    },
    {
        name: 'Kettlebell',
        icon: () => <Icon.Kettlebell />,
    },
    {
        name: 'Martial Arts',
        icon: () => <Icon.MartialArts />,
    },
    {
        name: 'Military',
        icon: () => <Icon.Military />,
    },
    {
        name: 'Pilates',
        icon: () => <Icon.Pilates />,
    },
    {
        name: 'Spinning',
        icon: () => <Icon.Spinning />,
    },
    {
        name: 'Stretching',
        icon: () => <Icon.Stretching />,
    },
    {
        name: 'Swimming',
        icon: () => <Icon.Swimming />,
    },
    {
        name: 'Tabata',
        icon: () => <Icon.Tabata />,
    },
    {
        name: 'Water Aerobics',
        icon: () => <Icon.WaterAerobics />,
    },
    {
        name: 'Weight Training',
        icon: () => <Icon.WeightTraining />,
    },
    {
        name: 'Yoga',
        icon: () => <Icon.Yoga />,
    },
    {
        name: 'Cardio',
        icon: () => <Icon.Cardio />,
    },
    {
        name: 'Walking',
        icon: () => <Icon.Walking />,
    },
    {
        name: 'Running',
        icon: () => <Icon.Running />,
    },
    {
        name: 'Cycling',
        icon: () => <Icon.Cycling />,
    },
    {
        name: 'Strongman',
        icon: () => <Icon.Strongman />,
    },
    {
        name: 'TRX',
        icon: () => <Icon.TRX />,
    },
    {
        name: 'Rowing',
        icon: () => <Icon.Rowing />,
    },
    {
        name: 'Strength Training',
        icon: () => <Icon.StrengthTraining />,
    },
    {
        name: 'Gym',
        icon: () => <Icon.Gym />,
    },
];

export const getWorkoutTypes = () => {
    return types.map((type, index) => {
        return {
            id: index,
            name: type.name,
            icon: type.icon,
        };
    });
};



// WEBPACK FOOTER //
// ./src/data/workoutTypes.js